<form class="brochure-form" 
      [formGroup]="form">
      <input class="brochure-form__input" type="email" placeholder="Email address" formControlName="email">
      <button class="brochure-form__button" *ngIf="!isPending" (click)="onSubmit()">Send Brochure</button>
      <button class="brochure-form__button" *ngIf="isPending" disabled>Sending...</button>
</form>